import React from 'react';
import { NavLink } from 'react-router-dom';

class Navigation extends React.Component {

    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className={(this.props.bgcolor !== '') ? `header-nav navbar-collapse collapse ${this.props.bgcolor}` : 'header-nav navbar-collapse collapse'}>
                    <ul className="nav navbar-nav">
                        <li className="active">
                            <NavLink to={"/"}>Home</NavLink>
                            
                        </li>
                        <li>
                        <NavLink to={"/about"}>About us</NavLink>
                        </li>
                        <li>
                        <NavLink to={"/services"}>Services</NavLink>
                        </li>
                        <li>
                                <NavLink to={"/contactus"}>Contact us</NavLink>
                                </li>
                                <li>
                                <NavLink to={"/faq"}>FAQ</NavLink>
                                </li>
                        {/* <li>
                            <NavLink to={"/projects"}>Projects</NavLink>
                       
                        </li> */}
                        <li>
                          {/* <NavLink to={""}>Quicklinks</NavLink>  */}
                            <ul className="sub-menu">
                            {/* <li>
                                <NavLink to={"/contactus"}>Contact us</NavLink>
                                </li> */}
                                {/* <li>
                                <NavLink to={"/faq"}>FAQ</NavLink>
                                </li> */}
                                <li>
                                <NavLink to={"/blog-listing"}>Blog</NavLink>
                                    {/* <ul className="sub-menu has-child">
                                        <li><NavLink to={"/blog-grid"}>Blog Grid</NavLink></li>
                                        <li><NavLink to={"/blog-listing"}>Blog Listing</NavLink></li>
                                        <li><NavLink to={"/blog-masonary"}>Blog Masonry</NavLink></li>
                                    </ul> */}
                                </li>
                                {/* <li>
                                <NavLink to={"/error"}>Error 404</NavLink>
                                </li> */}
                              
                            </ul>
                        </li> 
                        {/* <li>
                            <NavLink to={"/login"}>Login</NavLink>
                       
                        </li>         
                        <li>
                            <NavLink to={"/register"}>Signup</NavLink>
                       
                        </li>        */}
                    </ul>
                </div>  
            </>
        );
    };
};

export default Navigation;